import { useConstructor } from './UseConstructor';

export default useConstructor;
